<template>
  <div class="general-container">
    <header>
      <div class="header-logo">
        <img src="../assets/logo.svg">
      </div>
      <div class="header-links">
        <router-link to="/about" class="temp">
          Sobre el proyecto
        </router-link>
        <Searchbar/>
      </div>
    </header>
    <section class="visualization-container" v-if="ready">
      <LeftPanel
        class="left-container"
        :mapJson="miniMapJson"
        :genre="panelGenre"
        :country="panelCountry"
        :selection="selection"
        @hover="hover"
        @unhover="unhover"
        @select="select"
        @genreHighlight="genreHighlight"
        @genreUnhighlight="genreUnhighlight"
        @yearSelection="yearHighlight"
        ref="leftPanel"
      />
      <Map
        class="mid-container"
        :records="records"
        :brRecords="brRecords"
        :selection="selection"
        @recordMouseover="recordMouseover"
        @recordMouseout="recordMouseout"
        ref="map"
      />
      <RightPanel
        class="right-container"
        :records="records"
        :selection="selection"
        @yearSelection="yearHighlight"
        @hover="hover"
        @unhover="unhover"
        @select="select"
        @cleanSelection="cleanSelection"
        ref="rightPanel"
      />
    </section>
  </div>
</template>

<script>
import LeftPanel from './map/LeftPanel.vue';
import RightPanel from './map/RightPanel.vue';
import Map from './map/Map.vue';
import Searchbar from './map/Searchbar.vue';
import * as miniMapJson from '../assets/la_map.json';

export default {
  name: 'MapView',
  components: {
    LeftPanel,
    RightPanel,
    Map,
    Searchbar,
  },
  metaInfo: {
    title: 'Cartografía Digital de la Literatura Latinoamericana',
    htmlAttrs: {
      lang: 'es'
    },
    meta: [
      {
        name: 'description',
        content: 'Cartografía Digital de la Literatura Latinoamericana | Visualización, archivo y preservación de obras digitales'
      },
    ]
  },
  data(){
    return {
      miniMapJson: miniMapJson.default,
      panelGenre: 'None',
      panelCountry: '',
      selection: {
        genre: null,
        country: null,
        years: null,
        technique: null,
        format: null,
        searchString: null,
      },
    }
  },
  computed: {
    searchString: function(){return this.$store.getters.getSearch},
    records: function(){return this.$store.getters.getRecords},
    brRecords: function(){return this.$store.getters.getBrRecords},
    ready: function(){return this.$store.state.ready}
  },
  watch: {
    searchString() {
      this.selection.searchString = this.searchString; 
    }
  },
  methods: {
    recordMouseover(record) {
      this.panelGenre = record.genre;
      this.panelCountry = record.country;
    },

    recordMouseout() {
      this.panelGenre = 'None';
      this.panelCountry = '';
    },

    countryHighlight(country){
      this.$refs.map.highlightCountry(country);
      this.panelCountry = country;
    },

    countryUnhighlight(){
      this.$refs.map.unhighlight();
      this.panelCountry = '';
    },

    genreHighlight(genre){
      this.$refs.map.hover('genre', genre);
      this.panelGenre = genre;
    },

    genreUnhighlight(){
      this.$refs.map.unhover();
      this.panelGenre = 'None'; 
    },

    yearHighlight(years){
      this.$refs.map.select('years', years);
    },

    hover(type, value){
      this.$refs.map.hover(type, value);
    },

    unhover(){
      this.$refs.map.unhover();
    },

    select(type, value) {
      this.selection[type] = value;
      this.$refs.map.select(type, value);
    },

    cleanSelection(){
      Object.keys(this.selection).forEach(k => this.selection[k] = null)
      this.$refs.leftPanel.cleanSelection();
      this.$refs.map.cleanSelection();
      this.$store.commit('updateSearch', '');
    }
  },
}
</script>

<style scoped>
  .general-container {
    height: 100%;
    width: 100%
  }

  header {
    display: flex;
    justify-content: space-between;
    height: 50px;
    margin: 0 40px;
    margin-top: 20px;
    margin-bottom: 40px;
    border-bottom: 1px solid var(--black);
    padding-bottom: 10px;
  }

  .header-logo {
    height: 100%;
  }

  .header-logo img {
    height: 100%;
  }

  .header-links {
    font-family: var(--courier);
    color: #aa4700;
    display: flex;
    align-items: flex-end;
  }

  .temp {
    margin-right: 3em;
  }

  @media only screen and (min-height: 725px) {
    header {
      margin-bottom: 40px;
    }
  }

 @media only screen and (max-height: 725px) {
   header {
     margin-bottom: 20px;
   }
 }

  .visualization-container {
    width:  100%;
    display: grid;    
    grid-template-columns: 1fr 3fr 1fr;
    padding: 0px 40px;
  }
</style>